/* Divine Leaf header: sticky state, mega menu, overlays (search, drawer, bag),
   predictive search and the Ajax bag drawer. No dependencies. */
(function () {
  'use strict';
  if (window.__dlhInit) return;
  window.__dlhInit = true;

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var header = $('[data-dlh]');
  if (!header) return;

  // Overlays and the bottom bar are position: fixed. Move them to <body> so a
  // transformed ancestor (page transitions) can't trap them.
  Array.prototype.slice.call(document.querySelectorAll('[data-dlh-panel], [data-dlbn]')).forEach(function (el) {
    if (el.parentNode !== document.body) document.body.appendChild(el);
  });
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && /dl-(header|bottom-nav)/.test(e.target.className || '')) location.reload();
    });
  }

  var cfg = {};
  try { cfg = JSON.parse(($('[data-dlh-config]') || {}).textContent || '{}'); } catch (e) { cfg = {}; }
  var root = cfg.root || '/';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var desktop = window.matchMedia('(min-width: 990px)');

  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(cents) {
    var fmt = cfg.moneyFormat || '₹{{amount}}';
    var n = Number(cents || 0) / 100;
    function grp(num, dec, th, ds) {
      var parts = num.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return parts.join(ds);
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return grp(n, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return grp(n, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return grp(n, 0, '.', ',');
      return grp(n, 2, ',', '.');
    }).replace(/<[^>]*>/g, '');
  }

  function imgUrl(src, w) {
    if (!src) return '';
    try {
      var u = new URL(src, location.origin);
      u.searchParams.set('width', w);
      return u.toString();
    } catch (e) { return src; }
  }

  /* ---------------- Sticky state ---------------- */
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      header.classList.toggle('is-scrolled', window.scrollY > 24);
      ticking = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------------- Mega menu ---------------- */
  var megaItems = $$('[data-dlh-mega-item]');
  var hoverTimer;
  function closeMegas(except) {
    megaItems.forEach(function (it) {
      if (it === except) return;
      it.classList.remove('is-open');
      var b = $('[data-dlh-mega-btn]', it);
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  }
  function openMega(it) {
    closeMegas(it);
    it.classList.add('is-open');
    var b = $('[data-dlh-mega-btn]', it);
    if (b) b.setAttribute('aria-expanded', 'true');
  }
  megaItems.forEach(function (it) {
    var btn = $('[data-dlh-mega-btn]', it);
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (it.classList.contains('is-open')) closeMegas(); else openMega(it);
    });
    it.addEventListener('mouseenter', function () {
      if (!desktop.matches) return;
      clearTimeout(hoverTimer);
      hoverTimer = setTimeout(function () { openMega(it); }, 90);
    });
    it.addEventListener('mouseleave', function () {
      clearTimeout(hoverTimer);
      hoverTimer = setTimeout(function () { it.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); }, 160);
    });
    it.addEventListener('focusout', function (e) {
      if (!it.contains(e.relatedTarget)) { it.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); }
    });
    $$('a', it).forEach(function (a) { a.addEventListener('click', function () { closeMegas(); }); });
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-dlh-mega-item]')) closeMegas();
  });

  /* ---------------- Account dropdown ---------------- */
  var accBtn = $('[data-dlh-account-btn]');
  var accMenu = $('#DlhAccountMenu');
  function closeAccount() {
    if (!accBtn || !accMenu) return;
    accMenu.hidden = true;
    accBtn.setAttribute('aria-expanded', 'false');
  }
  if (accBtn && accMenu) {
    accBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = accMenu.hidden;
      accMenu.hidden = !open;
      accBtn.setAttribute('aria-expanded', String(open));
    });
    document.addEventListener('click', function (e) { if (!e.target.closest('[data-dlh-account]')) closeAccount(); });
  }

  /* ---------------- Overlays: search, drawer, bag ---------------- */
  var current = null;
  var lastFocus = null;
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';

  function setOpeners(id, val) {
    $$('[data-dlh-open="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', String(val)); });
  }

  function openPanel(id, opener) {
    var panel = document.getElementById(id);
    if (!panel) return false;
    if (current && current !== panel) closePanel(true);
    lastFocus = opener || document.activeElement;
    closeMegas(); closeAccount();
    panel.hidden = false;
    // force reflow so the transition runs
    void panel.offsetWidth;
    panel.classList.add('is-open');
    document.documentElement.classList.add('dlh-lock');
    document.body.classList.add('dlh-lock');
    setOpeners(id, true);
    current = panel;
    setTimeout(function () {
      var target = $('[data-dlh-search-input]', panel) || $('[data-dlh-close]:not([class*="scrim"])', panel) || $(FOCUSABLE, panel);
      if (target) target.focus({ preventScroll: true });
    }, reduce ? 0 : 60);
    return true;
  }

  function closePanel(silent) {
    if (!current) return;
    var panel = current;
    current = null;
    panel.classList.remove('is-open');
    setOpeners(panel.id, false);
    document.documentElement.classList.remove('dlh-lock');
    document.body.classList.remove('dlh-lock');
    setTimeout(function () { if (!panel.classList.contains('is-open')) panel.hidden = true; }, reduce ? 0 : 420);
    if (!silent && lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-dlh-open]');
    if (opener) {
      e.preventDefault();
      var id = opener.getAttribute('data-dlh-open');
      if (current && current.id === id) { closePanel(); return; }
      openPanel(id, opener);
      return;
    }
    if (e.target.closest('[data-dlh-close]') && current) { e.preventDefault(); closePanel(); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (current) { closePanel(); return; }
      closeMegas(); closeAccount();
      return;
    }
    if (e.key === 'Tab' && current) {
      var f = $$(FOCUSABLE, current).filter(function (x) { return x.offsetParent !== null || x === document.activeElement; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  // Close the mobile drawer if the screen grows to desktop.
  var onBp = function () { if (desktop.matches && current && current.id === 'DlhDrawer') closePanel(true); };
  if (desktop.addEventListener) desktop.addEventListener('change', onBp); else if (desktop.addListener) desktop.addListener(onBp);

  /* ---------------- Drawer accordions ---------------- */
  $$('[data-dlh-acc]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var body = document.getElementById(btn.getAttribute('aria-controls'));
      var open = btn.getAttribute('aria-expanded') !== 'true';
      btn.setAttribute('aria-expanded', String(open));
      if (body) body.classList.toggle('is-open', open);
    });
  });

  /* ---------------- Predictive search ---------------- */
  var input = $('[data-dlh-search-input]');
  var results = $('[data-dlh-results]');
  var popular = $('[data-dlh-popular]');
  var searchTimer, searchCtrl, lastQ = '';

  function renderResults(q, data) {
    var res = (data && data.resources && data.resources.results) || {};
    var products = res.products || [];
    var cols = res.collections || [];
    var url = (cfg.searchUrl || '/search') + '?q=' + encodeURIComponent(q) + '&type=product';
    if (!products.length && !cols.length) {
      results.innerHTML = '<p class="dlh-search__empty">No matches for “' + esc(q) + '”. Try a deity, a prayer or a gift.</p>';
      return;
    }
    var html = '';
    if (products.length) {
      html += '<div class="dlh-search__group"><p class="dlh__eyebrow">Products</p><ul class="dlh-search__products">';
      products.slice(0, 6).forEach(function (p) {
        var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
        var price = Number(p.price) ? Math.round(Number(p.price) * 100) : 0;
        var cmp = Number(p.compare_at_price_max) ? Math.round(Number(p.compare_at_price_max) * 100) : 0;
        html += '<li><a class="dlh-search__product" href="' + esc(p.url) + '">' +
          (img ? '<img src="' + esc(imgUrl(img, 160)) + '" alt="" width="64" height="64" loading="lazy">' : '<span class="dlh-search__thumb"></span>') +
          '<span><span class="dlh-search__name">' + esc(p.title) + '</span>' +
          '<span class="dlh-search__price">' + (price ? money(price) : '') + (cmp > price ? '<s>' + money(cmp) + '</s>' : '') + '</span></span></a></li>';
      });
      html += '</ul></div>';
    }
    if (cols.length) {
      html += '<div class="dlh-search__group"><p class="dlh__eyebrow">Collections</p><ul class="dlh-search__cols">';
      cols.slice(0, 4).forEach(function (c) {
        html += '<li><a href="' + esc(c.url) + '"><span>' + esc(c.title) + '</span>→</a></li>';
      });
      html += '</ul></div>';
    }
    html += '<a class="dlh-search__all" href="' + esc(url) + '">View all results →</a>';
    results.innerHTML = html;
  }

  function runSearch(q) {
    if (searchCtrl) searchCtrl.abort();
    searchCtrl = window.AbortController ? new AbortController() : null;
    results.innerHTML = '<div class="dlh-search__loading" aria-hidden="true"></div>';
    var u = root + 'search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last';
    fetch(u, { headers: { Accept: 'application/json' }, signal: searchCtrl ? searchCtrl.signal : undefined })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (d) { if (q === lastQ) renderResults(q, d); })
      .catch(function (err) { if (err && err.name === 'AbortError') return; results.innerHTML = ''; });
  }

  if (input && results) {
    input.addEventListener('input', function () {
      var q = input.value.trim();
      lastQ = q;
      clearTimeout(searchTimer);
      if (popular) popular.hidden = q.length > 0;
      if (q.length < 2) { results.innerHTML = ''; if (searchCtrl) searchCtrl.abort(); return; }
      searchTimer = setTimeout(function () { runSearch(q); }, 220);
    });
    $$('[data-dlh-term]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        input.value = a.getAttribute('data-dlh-term');
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.focus();
      });
    });
  }

  /* ---------------- Bag ---------------- */
  var cartPanel = $('[data-dlh-cart]');
  var cartBody = $('[data-dlh-cart-body]');
  var cartFoot = $('[data-dlh-cart-foot]');
  var useDrawer = header.getAttribute('data-cart-mode') !== 'page' && !!cartPanel;

  function setCount(n) {
    $$('[data-dlh-count]').forEach(function (b) {
      var changed = b.textContent.trim() !== String(n);
      b.textContent = n;
      b.classList.toggle('is-empty', !n);
      if (changed && n && !reduce) { b.classList.remove('is-bump'); void b.offsetWidth; b.classList.add('is-bump'); }
    });
    $$('[data-dlh-cart-count]').forEach(function (b) { b.textContent = '(' + n + ')'; });
    $$('[data-dlh-cart-open]').forEach(function (a) { a.setAttribute('aria-label', 'Bag, ' + n + ' items'); });
  }

  function renderCart(cart) {
    setCount(cart.item_count);
    if (!cartBody) return;
    if (!cart.item_count) {
      cartBody.innerHTML = '<div class="dlh-cart__empty">' +
        '<svg class="dl-ico" width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" aria-hidden="true"><path d="M5.5 8.5h13l-1 11.5h-11Z"/><path d="M9 8.5V7a3 3 0 0 1 6 0v1.5"/></svg>' +
        '<p>' + esc(cfg.emptyText || 'Your bag is empty') + '</p>' +
        '<a href="' + esc(cfg.emptyLink || '/collections/all') + '">' + esc(cfg.shopLabel || 'Shop all') + '</a></div>';
      if (cartFoot) cartFoot.hidden = true;
      return;
    }
    var html = '';
    cart.items.forEach(function (it, i) {
      var opts = (it.options_with_values || []).filter(function (o) { return o.value && o.value !== 'Default Title'; })
        .map(function (o) { return esc(o.value); }).join(' · ');
      var props = it.properties ? Object.keys(it.properties).filter(function (k) { return k.charAt(0) !== '_' && it.properties[k]; })
        .map(function (k) { return esc(k) + ': ' + esc(it.properties[k]); }).join('<br>') : '';
      var orig = it.original_line_price > it.final_line_price ? '<s style="display:block;font-weight:400;color:#A39882;font-size:12px">' + money(it.original_line_price) + '</s>' : '';
      html += '<div class="dlh-cart__line" data-line="' + (i + 1) + '" data-key="' + esc(it.key) + '">' +
        '<a href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(imgUrl(it.image, 180)) + '" alt="" width="76" height="76" loading="lazy">' : '<span class="dlh-search__thumb" style="width:76px;height:76px"></span>') + '</a>' +
        '<div><a class="dlh-cart__name" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
        (opts ? '<div class="dlh-cart__variant">' + opts + '</div>' : '') +
        (props ? '<div class="dlh-cart__variant">' + props + '</div>' : '') +
        '<div class="dlh-cart__qty"><button type="button" aria-label="Decrease quantity" data-qty="' + (it.quantity - 1) + '">−</button>' +
        '<span aria-live="polite">' + it.quantity + '</span>' +
        '<button type="button" aria-label="Increase quantity" data-qty="' + (it.quantity + 1) + '">+</button></div></div>' +
        '<div class="dlh-cart__price">' + money(it.final_line_price) + orig +
        '<button type="button" class="dlh-cart__remove" data-qty="0">Remove</button></div></div>';
    });
    cartBody.innerHTML = html;
    if (cartFoot) cartFoot.hidden = false;
    var total = $('[data-dlh-cart-total]');
    if (total) total.textContent = money(cart.total_price);
  }

  function fetchCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { renderCart(c); return c; });
  }

  function openCart(opener) {
    if (!useDrawer) { location.href = root + 'cart'; return; }
    fetchCart().catch(function () {});
    openPanel('DlhCart', opener);
  }

  if (cartBody) {
    cartBody.addEventListener('click', function (e) {
      var b = e.target.closest('[data-qty]');
      if (!b) return;
      var line = b.closest('.dlh-cart__line');
      line.classList.add('is-busy');
      fetch(root + 'cart/change.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: line.getAttribute('data-key'), quantity: Math.max(0, parseInt(b.getAttribute('data-qty'), 10) || 0) })
      })
        .then(function (r) { if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'Could not update'); }); return r.json(); })
        .then(function (c) { renderCart(c); document.dispatchEvent(new CustomEvent('dlh:cart', { detail: c })); })
        .catch(function (err) {
          line.classList.remove('is-busy');
          var msg = document.createElement('p');
          msg.className = 'dlh-cart__variant';
          msg.style.color = '#9A3B2E';
          msg.textContent = err.message;
          line.children[1].appendChild(msg);
          setTimeout(function () { msg.remove(); }, 4000);
        });
    });
  }

  $$('[data-dlh-cart-open]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      if (!useDrawer) return;
      e.preventDefault();
      openCart(a);
    });
  });

  // Quick add from product cards (homepage rows, related products).
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('.dl-card form[action*="/cart/add"]')) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    fetch(root + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) })
      .then(function (r) { if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Could not add'); }); return r.json(); })
      .then(function () {
        if (btn) btn.textContent = 'Added ✓';
        if (useDrawer) openCart(btn); else fetchCart();
      })
      .catch(function (err) { if (btn) btn.textContent = err.message.length < 28 ? err.message : 'Sold out'; })
      .then(function () { setTimeout(function () { if (btn) { btn.disabled = false; btn.textContent = label; } }, 1800); });
  }, true);

  // Keep the count in sync when other scripts change the cart (product page).
  function syncFromEvent(e) {
    var n = e && e.detail && typeof e.detail.item_count === 'number' ? e.detail.item_count : null;
    if (n !== null) setCount(n); else fetchCart().catch(function () {});
  }
  document.addEventListener('cart:updated', syncFromEvent);
  document.addEventListener('ajaxProduct:added', function () {
    // The product page has its own add-to-bag drawer; don't stack ours on top of it.
    if (document.querySelector('.dlp-drawer.is-open')) { fetchCart().catch(function () {}); return; }
    fetchCart().catch(function () {});
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) fetchCart().catch(function () {}); });

  /* ---------------- Announcement fade ---------------- */
  $$('[data-dla]').forEach(function (bar) {
    var items = $$('[data-dla-item]', bar);
    if (items.length < 2 || reduce) return;
    var i = 0, paused = false;
    bar.addEventListener('mouseenter', function () { paused = true; });
    bar.addEventListener('mouseleave', function () { paused = false; });
    setInterval(function () {
      if (paused || document.hidden) return;
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4200);
  });

  window.DLHeader = { openCart: openCart, refreshCart: fetchCart, open: openPanel, close: closePanel };
})();
